import React from "react";

const getNoPermissionModalPlanDescription = ({
  plan,
  translationExists,
  translate
}) => {
  const options = [];
  const count = 10;

  for (let i = 1; i <= count; i++) {
    const text = `no-permission-modal-plan_${plan.name}-${i}_description`;

    if (!translationExists(text)) {
      continue;
    }

    options.push(
      <li key={text} className={"text-xs opacity-80 text-black"}>
        {translate(text)}
      </li>
    );
  }

  return (
    <>
      <strong className={"text-xs.1 text-black font-semibold mb-2 block"}>
        {translate(`no-permission-modal-plan_${plan.name}_title`)}
      </strong>
      {options.length > 0 ? <ul className={"ul-3_check"}>{options}</ul> : null}
    </>
  );
};

export default getNoPermissionModalPlanDescription;
